import { z } from 'my-zod'

export const DepartmentNumbersOptions = [
  '01517 - Central Planning',
  '01522 - European Facility ORV',
  '01974 - Facility Maintenance Plant 2',
  '01975 - Powertrain Sourcing',
  '01984 - Project Global Ops G',
  '01985 - Project Global Ops H',
  '01997 - Project Global Ops K',
  '01503 - COM Sales',
  '01505 - General Manager - TWC',
  '01506 - REX Engineering Admin',
  '01726 - Product Management - Snow/Victory',
  '01692 - Roseau Inventory Control',
  '01523 - Service Mgmt & Tools',
  '01600 - Buildings & Grounds - Medina',
  '01603 - Polaris Acceptance',
  '01605 - Medina Administration',
  '01609 - Web Applications',
  '01610 - Mpls LAN/WAN',
  '01611 - Mpls Applications',
  '01612 - Telephone',
  '01613 - PC Support',
  '01727 - Fabrication',
  '01728 - Snow Engineering',
  '01729 - Tech Pubs/Release System',
  '01730 - Engine Development',
  '01732 - Motorcycle Sales',
  '01733 - Accessories - ORV Products',
  '01734 - Service Dev & Warranty',
  '01735 - Tech Service',
  '01736 - Snow Racing',
  '01737 - Vermillion Operations',
  'GP150 - Engineering',
  'GP500 - After Sales Service',
  'GP600 - Direct COGS - Direct Mfg',
  'GP640 - Indirect COGS - Mfg Administration',
  'GP650 - Indirect COGS - Purchasing',
  'GP680 - Indirect COGS - Mfg Quality',
  'GP710 - Sales & Marketing - France',
  'GP730 - Sales & Marketing - Export',
  'GP860 - Administration',
  '15415 - Poland Engineering',
  '15499 - Manufacturing Start up',
  '11780 - Canada - Administration',
  '11781 - Canada - Distribution Center',
  '11782 - Canada - Service/Warranty',
  '11785 - Canada - NSC',
  '11786 - Canada - Direct Sales',
  '11787 - Canada General Mgr - REX',
  '11788 - Canada Motorcycle Sales',
  '11795 - Canada - Advertising',
  '12401 - INTL Administration',
  '12406 - Engineering',
  '12408 - Purchasing',
  '12450 - Chassis Paint',
  '12451 - Exh High Temp Paint',
  '12452 - INTL Paint Admin',
  '12453 - Tube Fabrication',
  '12454 - INTL Tube Admin',
  '12455 - INTL Chassis Weld Fab',
  '12456 - Exhaust Weld',
  '12457 - INTL Weld Admin',
  '12458 - Engine Line 1 (Ranger)',
  '12459 - Engine Line 2 (RZR)',
  '12460 - Brake Assembly',
  '12461 - INTL Engine Admin',
  '12462 - Veh Assy Line 1 (Ranger)',
  '12463 - Veh Assy Line 2 (RZR)',
  '12464 - Veh Assy Line 3 (ATV)',
  '12465 - INTL Vehicle Assem Admin',
  '12466 - Advanced Mfg',
  '12467 - INTL Paint Services',
  '12468 - INTL Quality',
  '12470 - INTL Human Resources',
  '12471 - INTL Direction & Security',
  '12472 - INTL Lean Mfg',
  '12473 - INTL EHS',
  '12474 - Injection Molding II',
  '12475 - INTL Plastics Inj Molding',
  '12476 - Injection Molding II',
  '12477 - Service Parts',
  '12478 - Pilot Area',
  '12479 - Liquid Paint',
  '17999 - International Sales',
  '19999 - International Sales',
  '12999 - International Sales',
  '01999 - International Sales',
  '01952 - Accounting',
  '01203 - TransAmerica',
  '16999 - International Sales',
  '04999 - International Sales',
  '18999 - International Sales',
  '02999 - International Sales',
  '10999 - International Sales',
  '07999 - International Sales',
  '16709 - Swissauto Engineering',
  '14999 - International Sales',
  '08999 - International Sales',
  '13999 - International Sales',
  '06999 - International Sales',
  '05999 - International Sales',
  '01807 - Liquid Paint',
  '01651 - Roseau Tube Fabrication',
  '01652 - Roseau Tube Fabrication OH',
  '01656 - Global Supply Chain and Procurement',
  '01657 - Global Logistics',
  '01658 - Roseau Injection Mold OH',
  '01659 - Strategic Value Improvement Sourcing',
  '01660 - Indirect Sourcing',
  '01661 - Sourcing Excellence',
  '01662 - Roseau Welding',
  '04722 - Engine Design',
  '01406 - M&A Eng-Temporary',
  '01996 - Project Global Ops J',
  '11732 - Motorcycle Sales',
  '04712 - Engineering Analysis',
  '15999 - International Sales',
  '15522 - European Facility ORV',
  '15984 - Project/EMEA Plant Integra',
  '01510 - Advertising - TWC',
  '01511 - General Manager - REX',
  '01512 - Brammo Engineering',
  '01693 - Powertrain Admin',
  '01615 - Human Resources',
  '01616 - Operations Dev Program',
  '01617 - Eng Dev Program',
  '01618 - Database and BI',
  '01620 - Aviation',
  '01621 - Business Development',
  '01627 - Legal/Product Liability',
  '01628 - Trade Compliance',
  '01629 - Product Compliance',
  '01515 - Chassis Systems Sourcing',
  '01516 - Small Vehicle Purchasing',
  '01738 - Vermillion Facilities',
  '01739 - Vermillion Admin',
  '01741 - Sales Operations',
  '01742 - Dealer Development',
  '01743 - Rocky Mountain Sales',
  '01744 - Southwest Sales',
  '01745 - Industrial Design',
  '01746 - Intl Sales-EMEA',
  '01749 - Intl Sales - APLA',
  '01750 - Gen Mgr/Prod Devel - Victory',
  '01754 - External Relations',
  '01756 - Accessories - On Road',
  '01757 - Events/Partnerships',
  '01759 - Snow Demo',
  '01761 - General Manager - Snowmobile',
  '01762 - General Manager -ATV',
  '01764 - North Central Sales',
  '01765 - South Central Sales',
  '01766 - Southeast  (Sales)',
  '01767 - Northeast  (Sales)',
  '01768 - LEV Engineering',
  '01769 - General Manager - LEV',
  '01772 - Defense General Mgr',
  '01773 - Intl Engineering - APLA',
  '01778 - First Shift Pick/Pack',
  '01779 - Second Shift Pick/Pack',
  '01780 - First Shift Receiving',
  '01781 - Second Shift Restock',
  '01782 - Second Shift PG&A Receiving',
  '01783 - First Shift Restock',
  '01785 - National Accounts',
  '01786 - PGA Sales',
  '01787 - PGA Marketing',
  '01788 - PGA Inventory Control',
  '01789 - PG&A E-COMM/MERCH',
  '01790 - PGA Administration',
  '01793 - Sales Dev Program',
  '01794 - Mid-Atlantic Sales',
  '01796 - Consumer Sales',
  '01797 - Service Publications',
  '01798 - Intl Sales to EMEA HQ',
  '01800 - GEM Assembly',
  '01801 - Kit Packaging',
  '01802 - SxS Assembly - Line 802',
  '01803 - Victory Assembly',
  '01804 - SxS Assembly - Line 804',
  '01805 - Welding',
  '01806 - Metal Paint',
  '01817 - Milford Warehouse',
  '01840 - Milford West QA',
  '01830 - Milford East QA',
  '01835 - Milford West ORV Assembly',
  '01832 - Milford East Warehouse',
  '01655 - Lean-Roseau',
  '01903 - Poland Mfg',
  '01404 - M&A Sales/Mktg-Temporary',
  '16401 - INTL Administration',
  '01499 - Poland Start-up',
  '01524 - Software Development',
  '07404 - Australia Sales',
  '19404 - INTL Sales',
  '08404 - New Zealand Sales',
  '13404 - INTL Sales',
  '19401 - INTL Administration',
  '13401 - INTL Administration',
  '07401 - Australia Administration',
  '14404 - INTL Sales',
  '01500 - Indian HW MC Eng',
  '01663 - NVH/Test  (Noise, Vibrations, and Harshness)',
  '01664 - Global Sourcing - Shanghai',
  '01665 - ORV Product Mgmt PT',
  '01666 - Roseau Metal Paint',
  '01667 - Wyoming Facility',
  '01670 - Roseau Liquid Paint',
  '01671 - Roseau Asm Mfg Engineering',
  '01672 - Roseau Final Assembly OH',
  '01673 - Roseau Line C Assembly',
  '14401 - INTL Administration',
  '01833 - Milford East Assembly',
  '01401 - M&A Admin-Temporary',
  '13613 - PC Support',
  '13749 - Intl Sales - APLA',
  '14619 - Recruiting',
  '14640 - Management IS',
  '14643 - IS',
  '14749 - Intl Sales - APLA',
  '01527 - AIXAM/MEGA Engineering',
  '01528 - Parts & Oil',
  '01529 - Accessories/Snow',
  '01530 - RiderX',
  '01532 - Motorcycle Sales-Central',
  '01533 - Motorcycle Sales-East',
  '01534 - Motorcycle Sales-West',
  '01619 - Recruiting',
  '01626 - Customer Excellence',
  '01799 - Eicher Eng - JV',
  '01836 - Milford East Admin',
  '01838 - Milford West Plant Service',
  '01694 - Roseau Human Resources',
  '01695 - Roseau Pilot',
  '01696 - Materials Management',
  '01697 - Plant Administration',
  '01698 - Mfg Administration',
  '01699 - Snow Mfg/Assembly',
  '01631 - Corporate Procurement',
  '01633 - Operations Accounting',
  '01635 - Financial Services',
  '01636 - Treasury',
  '01640 - AS400',
  '01641 - Roseau Accounting',
  '01642 - Manufacturing Applications',
  '01643 - Roseau CAD/LAN/WAN',
  '01644 - Lean',
  '01645 - Central Advanced Mfg Eng',
  '01647 - Corp Materials & Inv Mgmt',
  '01648 - Project Global Ops A',
  '01649 - SxS Purchasing',
  '01650 - Victory Purchasing',
  '01808 - Victory Administration',
  '01809 - Weld/Paint Administration',
  '01810 - Quality Assurance',
  '12469 - INTL Materials',
  '01812 - Inventory Control',
  '01813 - SL Assembly Administration',
  '01814 - SL Mfg Engineering',
  '01815 - Plant Services',
  '01816 - Shipping',
  '01818 - Human Resources',
  '01819 - Mfg Admin',
  '01822 - Slingshot Purchasing',
  '01824 - LEV Administration',
  '01823 - Indian Product Line',
  '01825 - TWC Assembly',
  '01826 - Liquid Paint Admin',
  '01827 - Milford Assembly',
  '01828 - TWC Administration',
  '01829 - Indian Midsize Assembly',
  '01900 - Mexico Administration',
  '01940 - Advanced Manufacturing',
  '01941 - Engine Assembly-G4',
  '01942 - Engine Case Press',
  '01944 - Engine Assembly-Large Displacement',
  '01945 - Engine Assembly-Midsize',
  '01948 - Engine Assembly-Snow & Q',
  '01951 - Mfg Administration Plant 1',
  '01953 - Human Resources Plant 1',
  '01954 - Quality Assurance Plant 1',
  '01955 - Materials Plant 1',
  '01957 - Up Fit Assembly',
  '01959 - Welding',
  '01960 - Painting',
  '01961 - Clutch Assembly',
  'zz01962 - Seats',
  '01963 - Off-Road Engine Assembly Plant 2',
  '01966 - Seat Admin',
  '01968 - Drive Train Admin',
  '01507 - Engineering - TWC',
  '01701 - NSC-Dealer Support',
  '01702 - General Manager - SxS',
  '01704 - Product Manager - ATVs',
  '01705 - Database Direct Marketing',
  '01706 - Sales Management',
  '01707 - Roseau Experience Center',
  '01712 - Engineering Analysis',
  '01969 - Clutch Assembly',
  '01972 - Quality Assurance Plant 2',
  '01973 - Materials Plant 2',
  '01501 - General Manager - Indian',
  '01502 - Advertising - Indian',
  '01518 - Packaging',
  '01519 - Spirit Lake Material/Inv Mgmt',
  '01520 - Utility Marketing',
  '01521 - Ohio Warehouse',
  '01674 - Roseau C Assembly Line',
  '01675 - Roseau Injection Mold',
  '01676 - Roseau Line B Assembly',
  '01677 - Roseau Brake/Strut Asm',
  '01678 - Roseau Line A Assembly',
  '01680 - Roseau Service Parts',
  '01681 - Roseau Welding OH',
  '01682 - Roseau Receiving',
  '01683 - Roseau Quality Assurance',
  '01684 - Roseau Controls/Mfg Eng',
  '01685 - Roseau Tool Engineering',
  '01686 - Roseau Plant Maintenance',
  '01687 - Shipping',
  '01688 - Snow Purchasing',
  '01689 - Finishing Overhead',
  '01690 - Quality Endurance',
  '01691 - CES Vehicle Controls & Subsystems',
  '01755 - Clothing',
  '01946 - Engine Assembly-Gemini & Marauder',
  '02401 - Administration',
  '02403 - INTL Warranty',
  '02404 - Sales & Marketing',
  '02407 - Inter Entity Sales & Marketing',
  '04401 - Administration',
  '04403 - INTL Warranty',
  '04404 - Sales & Marketing',
  '04406 - Inter Entity Engineering',
  '04407 - Inter Entity Sales & Marketing',
  '05401 - Administration',
  '05403 - INTL Warranty',
  '05404 - Sales & Marketing',
  '06401 - Administration',
  '06403 - INTL Warranty',
  '06404 - Sales & Marketing',
  '06407 - INTL Administration',
  '06412 - Inter Entity Admin',
  '10401 - Administration',
  '10403 - INTL Warranty',
  '10404 - INTL Sales',
  '10406 - Inter Entity Engineering',
  '10407 - Inter Entity Sales & Marketing',
  '10416 - INTL Engineering',
  '16406 - Engineering',
  '16408 - Inter Entity Purchasing',
  '17401 - Administration',
  '17404 - Sales',
  '17406 - Inter Entity Engineering',
  '17411 - INTL Corp Development',
  '18401 - Administration',
  '18403 - INTL Warranty',
  '18404 - Sales & Marketing',
  '01508 - Off Road Testing',
  '01509 - On Road Testing',
  '01713 - Advanced Technology',
  '01715 - ATV Engineering',
  '01716 - ATV Marketing Support',
  '01718 - Govt Direct Engineering',
  '01720 - Victory Development',
  '01721 - Engineering Support',
  '01722 - Engine Design',
  '01723 - Engineering Operations Administration',
  '01724 - Plastic Systems & Technology Dev',
  '01725 - SxS Engineering',
  '01839 - Milford West Weld',
  '01842 - Milford West Admin',
  '03999 - International Sales',
  '04750 - Motorcycle Division',
  '04756 - Accessories - On Road',
  '07402 - Australia Parts Warehouse',
  '07403 - Australia Warranty',
  '07952 - Accounting',
  '08403 - New Zealand Warranty',
  '12407 - INTL Administration',
  '12903 - Poland Mfg.',
  '13403 - INTL Warranty',
  '13407 - INTL Administration',
  '14403 - INTL Warranty',
  '14408 - INTL Purchasing',
  '16403 - INTL Warranty',
  '17403 - Warranty & Customer Service',
  '17407 - INTL Administration',
  '17412 - INTL Information Systems',
  '19403 - INTL Warranty',
  '19408 - INTL Purchasing',
  '19412 - INTL Information Systems',
  '19526 - APAC Distribution Sales',
  '01403 - INTL Warranty',
  '01987 - G&A ACQ Integration',
  '11746 - Intl Sales-EMEA',
  '17798 - International Sales to EMEA HQ',
  '01962 - On-Road Engine Assembly Plant 2',
  '01837 - Milford West Assembly',
  '01637 - Post Sales Surveillance',
  '01958 - Up Fitting Admin',
  '01841 - MILFORD WEST METAL PAINT',
  '01980 - Project Global Ops C',
  '01614 - Polaris Foundation',
  '01834 - Milford East Maintenance',
  '15469 - Materials Poland',
  '15468 - Quality Poland',
  '01602 - Buildings & Grounds - Bass Creek',
  'zz01637 - Lean – Corporate',
  '15401 - Administration Poland',
  '17419 - Procurement',
  '01537 - Vortex Engineering - APLA',
  '15418 - IS Poland',
  '15450 - Paint Poland',
  '15455 - Weld Poland',
  '15462 - Veh Assy Line 1 Poland',
  '15463 - Veh Assy Line 2 Poland',
  '15464 - Veh Assy Line 3 Poland',
  '15470 - HR Poland',
  '15471 - Mfg Admin Poland',
  '15472 - Lean Mfg Poland',
  '15473 - Health & Safety Poland',
  '15480 - Facilities Poland',
  '15481 - Compliance Poland',
  '15419 - Poland Procurement',
  '01550 - Pro Armor Corp S&M',
  '01709 - Swissauto Engineering',
  '21401 - Mexico Sales G&A',
  '01547 - Utility Product Planning',
  '01548 - ORV Product Line Sales',
  '01549 - ORV Marketing',
  '01539 - RZR Accessories',
  '01540 - Ranger Accessories',
  '01541 - Fernley Admin',
  '01542 - Indian Accessories',
  '01546 - PGA Category Operations',
  '01545 - PGA Kolpin',
  '01536 - RZR Engineering',
  '01538 - ORV Systems & Design',
  'zz01791 - Field Ops & Training - Sales',
  '01554 - Market Development',
  '01763 - Com Sales Operations',
  '01624 - Corporate Tax',
  '01556 - General Manager - Work Dealer',
  '01557 - General Manager - Direct (National Accts)',
  '01979 - Project Global Ops B',
  '17221 - Business Operations',
  '17222 - Product Planning',
  '17402 - Warehouse Dept Expense',
  '17413 - Marketing',
  '17415 - Engineering Industrial Design',
  '17420 - Finance',
  '17481 - Compliance',
  '21405 - Sales',
  '21407 - Sales Dist CAC',
  '21416 - Interactive Customer Experience',
  '01553 - Premier Corp S&M',
  'COST_CENTER-3-457 - MEX Sales to Corp G&A',
  '21404 - Mexico Sales',
  '01708 - OSPS Engineering',
  '01977 - S&M ACQ Integration',
  '01991 - G&A ACQ Integration 2 (Brammo)',
  'COST_CENTER-3-462 - General Manager - Direct',
  '01555 - Work Dealer Eng',
  '01843 - MW Kits',
  '01552 - PRO ARMOR CORP MFG',
  '01551 - PRO ARMOR CORP G&A',
  '15482 - Tibmal Whse',
  '07504 - Australia Perth Retail',
  '12480 - MEXICO VEH.ASSY LINE 5',
  '01543 - GEM Accessories',
  '01544 - SLINGSHOT Accessories',
  '12481 - MEXICO VEH.ASSY LINE 4',
  '20415 - Swiss Mfg Engineering',
  '04416 - Great Britain to Corp G&A',
  '17421 - EMEA NonMgmt REX BussDevel',
  '17422 - EMEA NonMgmt IS',
  '01558 - Mfg Timbersled',
  '01559 - Engineering Timbersled',
  '01560 - General Mgr Timbersled',
  '01561 - Admin Timbersled',
  '01562 - Hammerhead US Operations',
  '19423 - China Materials to Corp',
  '21412 - Mexico Sales IS to Corp',
  '01844 - Milford East Welding',
  '01845 - Knock Down Asmbly-Mtrcycle',
  '17424 - EMEA NonMgmt Eng',
  'HHCH401 - Hammerhead China',
  '14412 - India IS',
  '01831 - Victory Midsize Assembly',
  '01982 - Project Global Ops E',
  '01989 - Project/SL Capacity Expansion',
  '01860 - HSV Plant Admin',
  '01861 - HSV HR',
  '01862 - HSV Weld',
  '01863 - HSV Metal Paint',
  '01864 - HSV Liquid Paint',
  '01865 - HSV Vehicle Assembly Line 1',
  '01866 - HSV Vehicle Assembly Line 2',
  '01867 - HSV Vehicle Assembly Line 3',
  '01868 - HSV Vehicle Assembly Line 4',
  '01869 - HSV Vehicle Assembly Line 5',
  '01871 - HSV Mfg Engineering',
  '01872 - HSV Mfg Plant Services',
  '01873 - HSV Materials',
  '01874 - HSV Quality',
  '01875 - HSV Tube Fab',
  '01876 - HSV Inj. Mold',
  '01877 - HSV Shipping',
  '01563 - Shakopee Whse (ZeroBased)',
  '01870 - HSV Mfg Admin',
  '04426 - GB Sales Goupil PL',
  '12482 - Compliance Mexico Mfg',
  '01846 - Spearfish Mfg',
  '01847 - Spearfish Mfg Admin',
  '01848 - Spearfish Plant Services',
  '07412 - Australia IS to Corp',
  '13402 - Brazil Parts Whse',
  '01770 - CGD Advertising',
  '01504 - CGD Service',
  '01565 - Engine Calibration',
  '01569 - Engineering Kolpin',
  '01570 - Whse Direct Kolpin',
  '01571 - Whse Admin Kolpin',
  '01572 - Whse Kitting Kolpin',
  '01573 - Customer Excellence Kolpin',
  '01574 - Mfg Overhead Premier',
  '01564 - Advanced Mfg Eng',
  'COST_CENTER-3-528 - Engine Calibration',
  '01566 - Digital Design & Experience',
  '01567 - PT Development Lab',
  '01568 - APLA MC',
  '01575 - 509 Corp S&M',
  '01981 - Project Global Ops D',
  '01983 - Project Global Ops F',
  '01986 - Project Global Ops I',
  '01576 - Trail Tech Corp Sales',
  '01577 - CES Hardware Development',
  '01578 - Trail Tech Gauge Mfg',
  '01579 - Taylor Dunn Start Up G&A',
  'GP401 - Goupil Administration',
  '15422 - IS Poland',
  '14416 - India G&A to Corp',
  '01580 - US ENG TO POLAND',
  '01904 - US MFG TO POLAND',
  '01581 - TaylorDunn Corp MFG',
  '01878 - HSV Sub Assembly',
  '01582 - Software Development - PRIMORDIAL',
  'COST_CENTER-3-548 - PROJECT GLOBAL OPS I',
  '14432 - India Trade Compliance to Corp',
  '01588 - TAP CORP ADMIN',
  '15466 - Advanced Mfg Poland',
  '04410 - GB Defense',
  '01586 - SL Env Health & Safety (EHS)',
  '15483 - Mfg Engineering Poland',
  '01879 - HSV Env Healthy Safety (EHS)',
  '01880 - HSV Lean',
  '01591 - Centralized Mfg Quality',
  '01583 - TaylorDunn Corp ENG',
  '01584 - PG&A 3rd Party Whses',
  '01585 - ROS Env Health Safety (EHS)',
  '01587 - OSC Env Health Safety (EHS)',
  '01589 - Supplier Quality',
  '01590 - Centralized Mfg Admin',
  '01592 - Design Assurance',
  '01784 - Ohio Whse Direct Labor',
  '01593 - Sustaining Engineering',
  '01594 - Central VIP Engineering',
  '01595 - ORV Consumer Research',
  '01596 - ORV Marketing Digital Web',
  '15484 - Poland Logistics to EMEA_M',
  '15431 - Poland Warranty to EMEA_M',
  '17427 - EMEA NonMgmt Finance',
  '01597 - Motorcycle Sales - South',
  '01881 - HSV UPFIT',
  '01758 - Great Lakes Sales',
  'AM401 - Aixam Administration',
  '17408 - EMEA Global Sourcing to Corp',
  '01911 - CGD Sales Ops',
  '01811 - SL Materials',
  '01914 - General Mgr Polaris Adventures',
  '01882 - HSV Service Parts',
  '01598 - IS Central Management',
  '01599 - Motorcycle Merchandising',
  '01905 - Engineering Systems and Training',
  '01906 - ORV Engineering Admin',
  '01907 - MC Systems & Design',
  '01908 - Advanced Technology & IP',
  '01909 - CES Software Development',
  '01910 - Indian Racing',
  '01912 - PGA ORV Marketing',
  '01913 - PGA MC Marketing',
  '01915 - Klim Corp G&A',
  'GP404 - Field Sales & Service',
  'GP409 - Service Operations',
  '01916 - Great Lakes Sales',
  '01525 - L&T Engineering',
  '22401 - Administration',
  '22403 - INTL Warranty',
  '22404 - Sales & Marketing',
  '01994 - Administration Allocation',
  '12483 - MEXICO MFG ENGINEERING',
  '02408 - Global Sourcing to Corp',
  '01792 - Digital Strategy',
  '01918 - PGA PD&D Ops',
  '14415 - India Eng to Corp',
  '01646 - CGD Mfg',
  '01917 - Mfg Tech & Optimization',
  '01740 - Fixed Operations',
  '01791 - Channel Advantage',
  '01929 - Accounting Services',
  '01925 - Electrification & Autonomy Eng',
  '01883 - HSV Features and Options',
  '01919 - Fernley 3PL',
  '01920 - Fernley Direct Labor',
  '01921 - Fernley Facilities',
  '01922 - Fernley Packaging',
  '01928 - Government General Mgr',
  '01923 - Powertrain Quality',
  '01924 - Product Safety Eng',
  '01926 - Engineering IP',
  '01927 - GENERAL Eng',
  '15460 - Veh Assy Line 4 Poland',
  '22405 - Finland Adv',
  'GP434 - Sales Operations',
  '01930 - Central DTV',
  '01931 - NPI Supplier Development',
  '01932 - Lean Corporate',
  '12484 - Mexico Veh Assy Line 6',
  'HHCH408 - Purchasing',
  '01933 - General Mgr Boats',
  '01934 - Indian Service',
  '23401 - Japan G&A',
  '23403 - Japan Warranty',
  '23404 - Japan Sales',
  '23405 - Japan Advertising',
  '15467 - Tool Room/Maint Poland',
  '01601 - Bldg & Grds Plymouth',
  '01902 - Mexico Purchasing',
  '12496 - Manufacturing Start Up',
  '01885 - MC Product Mgmt PT',
  '01886 - CES Program Mgmt',
  '01884 - Indian MidSize MC Eng',
  '01859 - CGD Engineering',
  '01887 - SNOW NPI Engineering',
  '01888 - ORV NPI Engineering',
  '01889 - MC NPI Engineering',
  '01606 - Northland Building',
  '01849 - PGA Operations',
  '01850 - PGA EComm Investment',
  '01851 - PGA Finance',
  '01852 - PGA Human Resources',
  '01853 - PGA R3 Whse Costs',
  '01854 - Ohio Whse Packaging',
  '01890 - CGD Human Resources',
  '01891 - CGD Finance',
  '01892 - ORV Human Resources',
  '01893 - ORV Finance',
  '01894 - MC Human Resources',
  '01895 - MC Finance',
  '01896 - MC Manfuacturing Operations',
  '01897 - ORV Manfuacturing Operations',
  '01898 - SNOW Manfuacturing Operations',
  '01899 - CGD Manfuacturing Operations',
  '02434 - Germany ORV Sales',
  '04434 - Great Britain ORV Sales',
  '07434 - Australia ORV Sales',
  '10434 - France ORV Sales',
  '17434 - Switzerland ORV Sales',
  '21434 - Mexico ORV Sales',
  '02436 - Germany Motorcycle Sales',
  '04436 - Great Britain Motorcycle Sales',
  '07436 - Australia Motorcycle Sales',
  '10436 - France Motorcycle Sales',
  '17436 - Switzerland Motorcycle Sales',
  '21436 - Mexico Motorcycle Sales',
  '01710 - Modern Workplace',
  '01855 - Corp Brand & Partnerships',
  '01935 - GOV Marketing',
  '01936 - GOV Service',
  '01937 - GOV Program Mgmt',
  'TAP99 - TAP Placeholder',
  '01949 - Engine Sub Assembly',
  '01947 - Materials Eng & Testing',
  '01965 - GEOps Admin',
  '01967 - CES Admin',
  '01632 - Reveo',
  '01634 - Subscriptions',
  '14487 - India HR to Corp',
  '15437 - Poland NonMgmt Compliance',
  '01939 - ORV CXM',
  '01938 - ORV Advanced Technology',
  'PREMIER - Premier OEM Placeholder',
  'Boats Placeholder',
  'Taylor-Dunn Manufacturing Placeholder',
  'Teton Outfitters Placeholder',
  'MCO Monticello Manufacturing Placeholder',
  '15439 - Poland Service to EMEA',
  '01669 - Roseau D Assembly Line',
  '01857 - PGA Global Apparel & Emp Stores',
  '22407 - Finland to EMEA Sales',
  '15474 - Material Flow Engineering',
  '15453 - Service Parts',
  '11789 - Klim Canada',
  '01964 - POU Asset Management',
  '24115 - Klim Corp G&A',
  '24102 - Klim Sales',
  '24104 - Klim Product',
  '24103 - Klim Marketing',
  '24116 - Klim Supply Chain',
  '24215 - 509 Corp S&M',
  '24203 - 509 Marketing',
  '24202 - 509 Sales',
  '24204 - 509 Product',
  '24216 - 509 Supply Chain',
  '24315 - Teton Outfitters Admin',
  '24313 - Teton HR',
  '24319 - Teton Outfitters Distribution & Logistics',
  '24338 - Teton Outfitters Finance',
  '24312 - Teton Outfitters D&IT',
  '24310 - Teton Outfitters Demand Planning',
  '01950 - EV Battery Assembly',
  '01638 - Corp Dev-Adv Tech',
  '01978 - Godfrey Accessories',
  '01703 - Utility Advertising',
  '01753 - Recreation Advertising',
  '01731 - Recreation Marketing',
  '01776 - Recreation Product Planning',
  '01630 - Service Marketing',
  '01607 - Electrical Chassis Systems Sourcing',
  '01608 - Supply Chain Risk Management',
  '01777 - General Manager-GDFRY',
  '01752 - Central Advertising',
  '01639 - Intellectual Property'
] as const

export const DepartmentNumbersEnum = z.enum(DepartmentNumbersOptions)
